export const Header = () => {
	return (
		<div className="flex mt-3 mb-3 flex-col justify-center items-center gap-2">
			<h3 className="text-blue-500 font-bold text-[25px]">LOGIN</h3>
			<p className="text-blue-300 text-[15px] m-0 text-gray-400">Sistem Rekapitulasi Prestasi</p>
		</div>
	);
};
